<template>
    <div>
      <div class="ibox float-e-margins">
        <affiliate-company-header></affiliate-company-header>
        <affiliate-company-content></affiliate-company-content>
      </div>
    </div>
  </template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { AFFILIATE_COMPANY_SET } from '../../../store/mutation-types'

import Header from './AffiliateCompany/Header'
import Content from './AffiliateCompany/Content'
export default {
  components: {
    affiliateCompanyHeader: Header,
    affiliateCompanyContent: Content
  },
  mounted () {
    this.loadAffiliateCompany()
  },
  methods: {
    async loadAffiliateCompany () {
      try {
        let resp = await axios.get(`/advertisers/affiliate-companies/${this.$route.params.id}`)
        this.$store.commit(AFFILIATE_COMPANY_SET, resp.data)
      } catch (error) {
        this.$toastr.error('Failed loading lists', error)
      }
    }
  },
  computed: {
    ...mapGetters({
      affiliateCompany: 'getAffiliateCompany'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/AffiliateCompany.vue